import React from "react";
import moment from "moment";
import FormatNumber from "../../components/common/NumberFormat";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Badge } from "react-bootstrap";
import { badge } from "../../components/common/Utils";
import { adminResellerCommission } from "../reseller/resellerCollection/CommissionShear";

const PrintReport = React.forwardRef((props, ref) => {
  const { t } = useTranslation();
  const { currentCustomers, filterData, status } = props;

  //user role
  const userRole = useSelector((state) => state.persistedReducer.auth.role);

  //user Data
  const userData = useSelector((state) =>
    userRole === "manager"
      ? state.persistedReducer.auth.ispOwnerData
      : state.persistedReducer.auth.userData
  );

  // get all reseller data from redux store
  const reseller = useSelector((state) => state?.reseller?.reseller);

  // get all packages
  const allPackages = useSelector((state) => state.package.allPackages);

  const startDate = moment(filterData.startDate).format("DD/MM/YYYY");
  const endDate = moment(filterData.endDate).format("DD/MM/YYYY");

  // customer package find
  const getCustomerPackage = (pack) => {
    const findPack = allPackages.find((item) => item.id.includes(pack));
    return findPack;
  };
  return (
    <>
      <div ref={ref}>
        <div className="page_header letter_header d-flex justify-content-between align-items-center pb-3 ">
          <div className="logo_side">
            <div className="company_logo">
              <img src="/assets/img/logo.png" alt="" />
            </div>
            <div className="company_name">{userData.company}</div>
          </div>
          <div className="details_side">
            <p>
              {t("companyName")} {userData.company}
            </p>
            {userData.address && (
              <p>
                {t("address")} : {userData?.address}
              </p>
            )}
          </div>
        </div>

        {status === "report" && (
          <ul className="d-flex justify-content-evenly mb-1">
            <li>
              {t("area")} : {filterData.area}
            </li>
            <li>
              {t("subArea")} : {filterData.subArea}
            </li>
            <li>
              {t("collector")} : {filterData.collector}
            </li>
            <li>
              {t("date")} : {startDate} - {endDate}
            </li>
          </ul>
        )}

        {status === "collection" && (
          <ul className="d-flex justify-content-evenly mb-1">
            <li>
              {t("reseller")} : {filterData.reseller}
            </li>

            <li>
              {t("medium")} : {filterData.medium}
            </li>

            <li>
              {t("date")} : {startDate} - {endDate}
            </li>
          </ul>
        )}

        <ul className="d-flex justify-content-evenly mb-1">
          <li>
            {t("totalData")} {currentCustomers.length}
          </li>

          <li className="ms-4">
            {t("totalBill")}: ৳{filterData.totalBill}
          </li>
        </ul>

        <table className="table table-striped ">
          <thead>
            <tr className="spetialSortingRow">
              <th scope="col">{t("id")}</th>

              <th scope="col">{t("pppoeIp")}</th>

              <th scope="col">{t("package")}</th>

              {status !== "collection" && <th scope="col">{t("discount")}</th>}

              <th scope="col">{t("due")}</th>

              <th scope="col">{t("medium")}</th>

              <th scope="col">{t("collected")}</th>

              {status === "collection" && (
                <th scope="col">{t("commission")}</th>
              )}

              <th scope="col">{t("note")}</th>

              <th scope="col">{t("date")}</th>
            </tr>
          </thead>
          <tbody>
            {currentCustomers.map((row, key) => (
              <tr key={key} id={row?.id}>
                <td className="prin_td align-middle">
                  <p className="text-center">
                    {row?.hotspotCustomer
                      ? row?.hotspotCustomer?.customerId
                      : row?.customer?.customerId}
                  </p>
                  <p style={{ fontWeight: "600" }}>
                    {row.customer?.userType === "pppoe"
                      ? "PPPoE"
                      : row.customer?.userType === "static"
                      ? "Static"
                      : row.hotspotCustomer?.userType === "hotspot"
                      ? "Hotspot"
                      : ""}
                  </p>
                </td>

                <td className="prin_td align-middle">
                  <p>
                    {row?.hotspotCustomer
                      ? row.hotspotCustomer?.name
                      : row.customer?.name}
                  </p>
                  <p>
                    {row?.customer?.userType === "pppoe"
                      ? row?.customer?.pppoe?.name
                      : row?.customer?.userType === "static"
                      ? row?.customer?.queue?.target
                      : row?.hotspotCustomer?.hotspot?.name}
                  </p>
                </td>

                <td className="prin_td align-middle">
                  <p>
                    {row.customer?.userType === "pppoe"
                      ? row.customer?.mikrotikPackage?.name
                      : row.customer?.userType === "static"
                      ? `${
                          row.customer?.uploadPackage
                            ? row.customer?.uploadPackage?.name
                            : row.customer?.mikrotikPackage?.name
                        }/${
                          row.customer?.downloadPackage
                            ? row.customer?.downloadPackage?.name
                            : row.customer?.mikrotikPackage?.name
                        }`
                      : row.hotspotCustomer?.hotspotPackage?.name}
                  </p>
                  <p style={{ fontWeight: "500" }}>৳{row?.amount}</p>
                </td>

                {status !== "collection" && (
                  <td className="prin_td align-middle">
                    <p>{FormatNumber(row?.discount)}</p>
                  </td>
                )}

                <td className="prin_td align-middle">
                  <p>{FormatNumber(row?.due)}</p>
                </td>

                <td className="prin_td align-middle text-center text-capitalize">
                  <p style={{ fontWeight: "500" }}>{row?.medium}</p>
                  <p style={{ fontWeight: "600" }}>{row?.billingType}</p>
                </td>

                <td className="prin_td align-middle">
                  <p>{row?.name}</p>
                </td>

                {status === "collection" && (
                  <td className="prin_td align-middle">
                    <p>
                      {t("admin")} &nbsp;
                      <span style={{ fontWeight: "500" }}>
                        ৳
                        {row?.ispOwnerCommission
                          ? row?.ispOwnerCommission
                          : adminResellerCommission(reseller, row)
                              ?.ispOwnerCommission}
                      </span>
                    </p>

                    <p>
                      {t("own")} &nbsp;
                      <span style={{ fontWeight: "500" }}>
                        ৳
                        {row?.resellerCommission
                          ? row?.resellerCommission
                          : adminResellerCommission(reseller, row)
                              ?.resellerCommission}
                      </span>
                    </p>
                  </td>
                )}

                <td className="prin_td align-middle">
                  <p>{row?.month}</p>
                </td>
                <td className="prin_td align-middle">
                  <p>{moment(row?.createdAt).format("YYYY-MM-DD HH:mm A")}</p>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
});

export default PrintReport;
